import { MediaApp } from "./app";

export default function DamApp(props) {
  return <MediaApp></MediaApp>;
}
